import {
    NinchatActionType,
    NinchatEndAudienceAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const endAudience = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatEndAudienceAction}`,
    async (arg: NinchatActionParams<NinchatEndAudienceAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatEndAudienceAction

        try {
            return await ninchatClient.send(params)
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
